export default __webpack_public_path__ + "static/media/casuals.e3550fbd.gif";